import { createContext, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { TooltipProvider } from 'modules/v2/dataDisplay/Tooltip/TooltipProvider';
import { ToastProvider } from 'modules/v2/feedback/Toast';
import { InterFontFace } from 'modules/v2/foundation/theme/typography/InterFontFace';
import { ThemeVariables } from './ThemeVariables';
// import { ThemePath } from './themeGet';
import { getTheme } from './themes';
import { PortalProvider } from '../PortalProvider';
export const TetrisThemeContext = createContext(null);
export function TetrisThemeProvider(props) {
    const { children, theme = 'light' } = props;
    const [themeType, setThemeType] = useState(theme);
    const value = {
        themeType,
        setThemeType,
    };
    const currentTheme = getTheme(themeType);
    return (<TetrisThemeContext.Provider value={value}>
      <ThemeProvider theme={currentTheme}>
        <ThemeVariables $theme={currentTheme}/>
        <InterFontFace />
        <PortalProvider />
        <ToastProvider>
          <TooltipProvider>{children}</TooltipProvider>
        </ToastProvider>
      </ThemeProvider>
    </TetrisThemeContext.Provider>);
}
